import ColorfulCrumb from './colorful-crumb';
export default ColorfulCrumb;
